import React, { useEffect, useState } from 'react'
import Classes from './Orders.module.css'
import { Pagination, Stack } from '@mui/material';
import useScreenWidth from '../../../../../../../../Hooks/useScreenWidth';
import SkeletonLoading from '../../../../../../../GlobalComponents/SkeletonLoading/SkeletonLoading';
import TableRow from './TableRow';
import { useNavigate } from 'react-router-dom';

export default function Orders() {
    const initialTasks = [
        {
            id: 1,
            name: "UI/UX Design",
            status: "Submitted",
            created: "March 1, 2025",
        },
        {
            id: 2,
            name: "SEO optimization",
            status: "Working",
            created: "March 1, 2025",
        },
        {
            id: 3,
            name: "SEO optimization",
            status: "Submitted",
            created: "March 1, 2025",
        },
        {
            id: 4,
            name: "SEO optimization",
            status: "Submitted",
            created: "March 1, 2025",
        },
        {
            id: 5,
            name: "SEO optimization",
            status: "Submitted",
            created: "March 1, 2025",
        },
    ];

    const [loading, setLoading] = useState(true);
    const navigateTo = useNavigate();
    const screenWidth = useScreenWidth();
    const isMobile = screenWidth <= 480;

    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 5;

    const totalPages = Math.ceil(initialTasks.length / itemsPerPage);
    const currentItems = initialTasks.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );
    const startItem = (currentPage - 1) * itemsPerPage + 1;
    const endItem = Math.min(currentPage * itemsPerPage, initialTasks.length);
    const totalItems = initialTasks.length;

    function handlePageChange(e, pageNum) {
        setCurrentPage(pageNum);
    }

    const handleAddOrder = () => {
        navigateTo('/add-order');
    }

    useEffect(() => {
        const timer = setTimeout(() => {
            setLoading(false);
        }, 1000);
        return () => clearTimeout(timer);
    }, []);


    return (
        <div>
            <div className={Classes.tableHeader}>
                <div className={`${Classes.headerItem} ${Classes.headerCustomer}`}>
                    <input type='checkbox' />
                </div>
                <div className={`${Classes.headerItem} ${Classes.headerSpendings}`}>
                    <h5>Name</h5>
                </div>
                <div className={`${Classes.headerItem} ${Classes.headerBookings}`}>
                    <h5>Status</h5>
                </div>
                <div className={`${Classes.headerItem} ${Classes.headerDate}`}>
                    <h5>Created</h5>
                </div>
                <div className={`${Classes.headerItem} ${Classes.headerDisable}`}>
                </div>
            </div>

            <div className={Classes.tableBody}>
                {loading ? (
                    <SkeletonLoading
                        length={itemsPerPage}
                        height={isMobile ? '6rem' : '2.8rem'}
                        width="100%"
                        br="6px"
                    />
                ) : currentItems && currentItems.length > 0 ? (
                    currentItems.map((cust, idx) => (
                        <TableRow
                            key={cust._id}
                            value={cust}
                            index={idx}
                        />
                    ))
                ) : (
                    <div>No data found.</div>
                )}
            </div>

            <div className={Classes.pagFooter}>
                <h5 style={{ height: '1.2rem' }}>
                    {loading
                        ? <SkeletonLoading height='1.2rem' width='10rem' br='4px' padding='0' />
                        : `Showing ${startItem} to ${endItem} of ${totalItems} results`
                    }
                </h5>
                <Stack spacing={2} className={Classes.pagination}>
                    {loading
                        ? <SkeletonLoading height='1.2rem' width='5rem' br='4px' padding='0' />
                        : <Pagination
                            count={totalPages}
                            page={currentPage}
                            onChange={handlePageChange}
                            shape="rounded"
                        />
                    }
                </Stack>
            </div>

        </div>
    )
}
